export enum MyChartPastHistoryTypes {
  PATIENT = 'patient',
  HOSPITAL = 'hospital',
  ALL = 'ALL',
}

export enum MyChartPastHistoryOtherValues {
  PAST_HISTORY_TYPE = 'pastHistoryType',
  SITUATION = 'situation',
}

export interface ComponentTarget {
  state: {
    alias: string;
  }
}

export interface FetchResponseData {
  disease: string;
  endDate: string;
  read: string;
  sequence: number;
  situation: string;
  startDate: string;
}

export interface PastHistoryFilter {
  filterFromDate?: string;
  filterUntilDate?: string;
  situation?: PastHistorySituationData;
}

export interface PastHistorySituationData {
  situationCode: string;
  situationDescription: string;
}